<template>
    <div class="products">
        <div class="container" style="font-size: 0;">

            <div class="join-four-top">
                <img src="https://youke1.picui.cn/s1/2025/08/27/68af17a1d2ff7.png" class="product-image"
                    alt="原鲜冬虫夏草"></img>
            </div>
            <div style="height: 120px;">

            </div>

            <joinSwper :goodList="productsA" joinType="left"></joinSwper>
            <joinSwper :goodList="productsB" joinType="right"></joinSwper>
            <div class="join-two">
                <div class="two-title">基地实地考察</div>
                <div class="two-list">
                    <div v-for="(item, index) in joinImgList" :key="index">
                        <img :src="item.img" alt="" class="join-img">
                    </div>
                </div>
                <div class="two-tips">
                    组织基地实地考察多方位深入了解企业，品牌，产品开发历程
                </div>

                <div class="three-title">
                    会员系统
                </div>
                <div>
                    <img src="https://youke1.picui.cn/s1/2025/08/27/68af160ae443c.png" style="width: 80%;" alt=""></img>
                </div>
                <div class="four-box">
                    <div class="four-title">
                        共赢商机，联系我们
                    </div>
                    <div class="four-phone">
                        招商热线：400-183-9888
                    </div>
                    <div class="four-btn">
                        立即加入
                    </div>

                </div>

            </div>







        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import joinSwper from '@/components/join-swper.vue'
const productsA = ref([
    {
        img: "https://youke1.picui.cn/s1/2025/08/26/68adcfbd44945.png",
        title: "品牌门店定制设计",
        tips: "从选址到开业"
    },
    {
        img: "https://youke1.picui.cn/s1/2025/08/26/68adcfbd0df3c.png",
        title: "品牌门店定制设计",
        tips: "从选址到开业"
    },
    {
        img: "https://youke1.picui.cn/s1/2025/08/26/68adcfbb8789b.png",
        title: "品牌门店定制设计",
        tips: "从选址到开业"
    }
])
const productsB = ref([
    {
        img: "https://youke1.picui.cn/s1/2025/08/26/68adcfbd223c1.png",
        title: "培训赋能，助力销售",
        tips: "系统培训行业知识，销售技巧"
    },
    {
        img: "https://youke1.picui.cn/s1/2025/08/26/68adcfbd05468.png",
        title: "培训赋能，助力销售",
        tips: "系统培训行业知识，销售技巧"
    },
    {
        img: "https://youke1.picui.cn/s1/2025/08/26/68adcfc53a41e.png",
        title: "培训赋能，助力销售",
        tips: "系统培训行业知识，销售技巧"
    },



])
const joinImgList = ref([
    { img: "https://youke1.picui.cn/s1/2025/08/26/68add15d57974.png" },
    { img: "https://youke1.picui.cn/s1/2025/08/26/68add15dcc7cd.png" },
    { img: "https://youke1.picui.cn/s1/2025/08/26/68add15dce0b7.png" },
])




</script>
<style scoped>
.products {
    width: 100%;
    min-width: 1400px;
    background-color: #F4ECE1;
    padding-top: 100px;
}

.four-box {
    border-top: 1px solid #CAA588;
    padding-bottom: 50px;
}

.four-title {
    color: #53423A;
    font-size: 32px;
    font-weight: bold;
    text-align: center;
    margin-top: 50px;

}

.four-phone {
    color: #806144;
    font-size: 36px;
    text-align: center;
    margin-top: 50px;

}

.four-btn {
    background-color: #B49880;
    color: white;
    padding: 20px;
    width: 280px;
    font-size: 32px;
    border-radius: 100px;
    text-align: center;
    margin: auto;
    margin-top: 70px;
    cursor: pointer;

}

.two-tips {
    color: #54433B;
    font-size: 20px;
}

.three-title {
    color: #54433B;
    font-size: 36px;
    margin-top: 20px;
    text-align: center;
    font-weight: bold;
}

.two-list {
    display: flex;
    justify-content: space-between;
    margin-top: 50px;
    padding-bottom: 20px;

}

.join-img {
    width: 95%;
    height: 100%;

}

.join-two {
    width: 80%;
    background-color: #F4ECE1;
    margin: auto;


}

.two-title {
    color: #826142;
    font-size: 33px;
}

.container {}

.join-four-top {
    min-width: 1400px;
    width: 100%;
    height: 1000px;
    padding-top: 90px;
    background: url("https://img.cdn1.vip/i/68b5ac470b8fd_1756736583.webp") no-repeat;
    background-size: cover;
    background-color: #F4ECE1;
    position: relative;
}



.product-image {
    width: 70%;
    height: 350px;
    z-index: 99;
    border-radius: 20px;
    position: absolute;
    left: 50%;
    bottom: -175px;
    transform: translateX(-50%);


}

.pro-title1 {
    color: #FDD097;
    font-size: 70px;
    text-align: center;
    padding-top: 50px;

}

.pro-title2 {
    color: #FDD097;
    font-size: 62px;
    text-align: center;
    margin-top: 15px;

}

.pro-list-top {
    color: #FCD197;
    font-size: 50px;
    text-align: center;
}

.pro-img {
    width: 300px;
    object-fit: cover;
    height: 300px;
    text-align: center;
}

.pro-list {
    display: flex;
    margin: auto;
    max-width: 1300px;
    justify-content: space-between;
    margin-top: 40px;
}

.pro-title {
    color: #FCD197;
    font-size: 32px;
    text-align: center;
    margin-top: 20px;
}

.pro-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
</style>
